import { render } from "./DeliveryPolicy.vue?vue&type=template&id=b6ffc492"
import script from "./DeliveryPolicy.vue?vue&type=script&lang=js"
export * from "./DeliveryPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__